import React, { useEffect } from "react";
import styles from "./Modal.module.scss";
import { IoMdClose } from "react-icons/io";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  children: React.ReactNode;
  showCloseIcon?: boolean;
  style?: React.CSSProperties;
}

function Modal(props: Props) {
  const { isOpen, setIsOpen, children, showCloseIcon = true, style } = props;

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  return (
    <div
      className={`${styles.mainContainer} ${
        isOpen ? styles.mainContainerActive : ""
      }`}
    >
      {isOpen && (
        <div className={styles.contentContainer} style={style}>
          {children}
          {showCloseIcon && (
            <div className={styles.iconContainer}>
              <IoMdClose
                className={styles.icon}
                size={25}
                onClick={() => setIsOpen(false)}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Modal;
